// extracted by mini-css-extract-plugin
export default {"product_detail__wrapper":"productdetail_product_detail__wrapper__UeecB","product_detail__slider_wrapper":"productdetail_product_detail__slider_wrapper__2ocxQ"};